/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpRightIcon20Light = forwardRef('ArrowDRadiusUpRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.854 2.646a.5.5 0 0 0-.708.708L16.793 8H9.5A7.5 7.5 0 0 0 2 15.5v1a.5.5 0 0 0 1 0v-1A6.5 6.5 0 0 1 9.5 9h7.293l-4.647 4.646a.5.5 0 0 0 .708.708l4.651-4.652a1.7 1.7 0 0 0 0-2.404l-4.651-4.652Z" })));
});
